import { Episode, EpisodeTranslationSummary } from '../../../types';

export type ContentTabKind = 'builtin' | 'translation';

export interface ContentTabDef {
  key: string;            // 'original' | 'annotated' | 'normalized' | 'trans:<language>'
  label: string;
  kind: ContentTabKind;
  language?: string;
  status?: EpisodeTranslationSummary['status'];
}

export function buildContentTabs(
  episode: Pick<Episode, 'annotatedContentURL' | 'normalizedContentURL'>,
  translations: EpisodeTranslationSummary[],
  t: (k: string) => string,
): ContentTabDef[] {
  const tabs: ContentTabDef[] = [];
  if (episode.annotatedContentURL) tabs.push({ key: 'annotated', label: t('content.annotatedTab'), kind: 'builtin' });
  if (episode.normalizedContentURL) tabs.push({ key: 'normalized', label: t('content.normalizedTab'), kind: 'builtin' });
  tabs.push({ key: 'original', label: t('content.originalTab'), kind: 'builtin' });
  for (const tr of translations) {
    tabs.push({ key: `trans:${tr.language}`, label: tr.language, kind: 'translation', language: tr.language, status: tr.status });
  }
  return tabs;
}
